import { gql } from 'urql'

export const FragArticleCard = gql`
  fragment ArticleCard on ArticleCard {
    id
    slug
    title
    guideName
    guideAvatarUrl
    guideId
    imageUrl
    readTimeInSeconds
    bookmarked
  }
`
